import handler from 'api/handler'

const prefix = '/public/contact'

const methods = {
  submit: args => handler({ method: 'post', url: prefix + '/submit', args }),
  getAll: args => handler({ method: 'get', url: prefix + '/all', args })
}

export default methods
